import type { CanvasNodeV3 as CanvasNode } from "@seedance/contracts";

export type SelectionConnectionDrop =
  | { kind: "connect"; targetNodeId: string }
  | { kind: "generate" };

export function resolveSelectionConnectionDrop({
  sourceNodeIds,
  targetNodeId,
  droppedOnPane,
  nodes
}: {
  sourceNodeIds: readonly string[];
  targetNodeId?: string;
  droppedOnPane: boolean;
  nodes: readonly Pick<CanvasNode, "id" | "kind">[];
}): SelectionConnectionDrop | undefined {
  if (sourceNodeIds.length === 0) return undefined;
  const target = targetNodeId === undefined ? undefined : nodes.find(({ id }) => id === targetNodeId);
  if (target?.kind === "seedance") return { kind: "connect", targetNodeId: target.id };
  return droppedOnPane ? { kind: "generate" } : undefined;
}
